import React, { FC } from 'react';
import { Flex, LoadingIndicator } from 'roo-ui/components';
import useForm from 'react-hook-form/dist/react-hook-form.ie11';
import styled from '@emotion/styled';
import { RequestCallbackDetails } from './RequestCallbackDetails';
import { RequestCallbackConfirmation } from './RequestCallbackConfirmation';

const Form = styled('form')`
  position: relative;
`;

const Overlay = styled(Flex)`
  align-items: center;
  justify-content: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.7);
`;

interface DetailsShape {
  fullName?: string;
  phoneNumber?: string;
  qffNumber?: string;
}

export interface RequestCallbackFormProps {
  onSubmit?: Function;
  onClose?: Function;
  isSubmitting?: boolean;
  isComplete?: boolean;
  prefilledDetails?: DetailsShape;
}

export const RequestCallbackForm: FC<RequestCallbackFormProps> = ({
  onSubmit = () => {},
  onClose = () => {},
  isSubmitting = false,
  isComplete = false,
  prefilledDetails = {},
}) => {
  const { register, errors, handleSubmit, setValue } = useForm({
    mode: 'onBlur',
  });

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      {isSubmitting && (
        <Overlay>
          <LoadingIndicator color="greys.steel" />
        </Overlay>
      )}
      {!isComplete && (
        <RequestCallbackDetails
          register={register}
          errors={errors}
          setValue={setValue}
          prefilledDetails={prefilledDetails}
        />
      )}
      {isComplete && <RequestCallbackConfirmation onClose={onClose} />}
    </Form>
  );
};
